import script from "./TagGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./TagGroup.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "C:\\wamp64\\www\\systems\\nova-erp-system\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"TagGroup.vue"]])

export default __exports__